// src/components/SelectedPhotosPage.js
import React, { useState, useEffect } from "react";
import "./EntranceForms.css";
import * as apiCall from "./../../api/apiCall";

const EntranceForms = ({
  setFormSubmit,
  postUser,
  config,
  setGain,
  setWin,
  setEmail,
}) => {
  const [formData, setFormData] = useState({
    code: "",
    nom: "",
    prenom: "",
    adresse: "",
    telephone: "",
    email: "",
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  async function checkCode(idConfig, code) {
    try {
      let data = await apiCall.checkCode(idConfig, code);
      return data;
    } catch (error) {
      console.error("Error fetching config:", error);
    }
  }

  async function getGains(idConfig) {
    try {
      let data = await apiCall.getGains(idConfig);
      console.log("gains data", data);
      setGain(data);
      if (data && Object.keys(data).length > 0) {
        setWin(true);
      }
      return data;
    } catch (error) {
      console.error("Error fetching gains:", error);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    if (/^\d*$/.test(value)) {
      setFormData({
        ...formData,
        telephone: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const codeCheckin = await checkCode(config.id, formData.code);
      if (codeCheckin.validity) {
        const gains = await getGains(config.id);
        await postUser(
          formData.prenom,
          formData.nom,
          formData.adresse,
          formData.telephone,
          formData.email,
          formData.code,
          gains.id,
          config.id
        );
        setEmail(formData.email);

        setFormSubmit(true);
        setLoading(false);
        setErrorMessage(""); // Effacer le message d'erreur en cas de succès
      } else {
        setLoading(false);
        setErrorMessage(
          "Le code entré n'est pas valide ou a déjà été utilisé."
        );
      }
    } catch (error) {
      console.error(
        "Une erreur s'est produite lors de la validation du code",
        error
      );
    }
  };
  return (
    <div className="forms">
      <div className="explanationText">
        <div className="header">Félicitations !</div>
        <div className="content">
          Vous êtes le chanceux détenteur d'un code unique, veuillez le
          renseigner ci-dessous
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="text"
            id="code"
            name="code"
            value={formData.code}
            placeholder="Code"
            onChange={handleChange}
            required
          />
        </div>
        {errorMessage && <div style={{ color: "black" }}>{errorMessage}</div>}
        <div className="content">
          Pour participer, merci de remplir tous les champs ci-dessous :
        </div>
        <div>
          <input
            type="text"
            id="nom"
            name="nom"
            value={formData.nom}
            placeholder="Nom"
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <input
            type="text"
            id="prenom"
            name="prenom"
            placeholder="Prénom"
            value={formData.prenom}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <input
            type="text"
            id="adresse"
            name="adresse"
            placeholder="Adresse"
            value={formData.adresse}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <input
            type="tel"
            id="telephone"
            name="telephone"
            placeholder="Téléphone"
            value={formData.telephone}
            onChange={handlePhoneChange}
            required
            inputMode="numeric"
          />
        </div>

        <div>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="submitButton">
          <button type="submit">
            {loading ? "Envoi en cours.." : "Envoyer pour jouer"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default EntranceForms;
